import styled from "styled-components";
import { getColor } from "../../../../../utils/color";

export const SectionContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 1rem;
    width: 95%;
    max-width: 1330px;
    margin: 3rem auto;
`;

export const Header = styled.div`
    width: 100%;
    display: flex;
    justify-content: space-between;
    margin: 0;
`;

export const SelectItemContainer = styled.ul`
    list-style: none;
    display: flex;
    gap: 0.5rem;
    margin: 0;
    padding: 0;
`;

export const SeletedItem = styled.li<{selected?: boolean}>`
    padding: 0.5rem 1rem;
    background-color: ${({selected, theme}) => !selected ? "#bbb" : theme.colors.primaryBlue.main};
    border-radius: 0.5rem;
    color: #fff;
    font-weight: 700;

    &:hover {
        cursor: pointer;
        background-color: ${({selected, theme}) => !selected 
            ? getColor(theme.colors.primaryBlue.main).hover
            : theme.colors.primaryBlue.main
        };
    }
`;